// @oasis-permission-inherits: /credits (credits:grant)
import { createFileRoute } from "@tanstack/react-router";

import { useAuthStore } from "~/modules/auth/auth-store";
import { CreditDebitForm } from "~/modules/credits/components/credit-debit-form";
import { CreditGrantForm } from "~/modules/credits/components/credit-grant-form";

export const Route = createFileRoute("/_dash/credits/")({
  component: RouteComponent,
});

function RouteComponent() {
  const [user] = useAuthStore((s) => [s.user]);
  const hasGrantCreditsPermission = user?.permissions.includes("credits:grant") ?? false;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-xl font-bold">Grant Credits</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Grant credits to users or organizations
        </p>
      </div>

      {hasGrantCreditsPermission ? (
        <CreditGrantForm />
      ) : (
        <p className="text-sm text-muted-foreground">
          You don&apos;t have permission to grant credits.
        </p>
      )}

      <div>
        <h1 className="text-xl font-bold">Debit Credits</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Remove credits from a user or organization
        </p>
      </div>

      {hasGrantCreditsPermission ? (
        <CreditDebitForm />
      ) : (
        <p className="text-sm text-muted-foreground">
          You don&apos;t have permission to debit credits.
        </p>
      )}
    </div>
  );
}
